import Request from './request';

export default class ApiService {
  static getAdditionalTileData(obfuscatedId: string): Promise<any> {
    const url = `/api/content_blocks/tile_container/${obfuscatedId}/additional_tile_data/`;

    return Request.getHelper(url);
  }
}
